import React, { FunctionComponent } from 'react';

import withIconContainer from './withIconContainer';

const IconCardMastercard: FunctionComponent = () => (
    <svg height="104" viewBox="0 0 156 104" width="156" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M144 104H12c-6.15 0-12-5.85-12-12V12C0 5.85 5.85 0 12 0h132c6.15 0 12 5.85 12 12v80c0 6.15-5.85 12-12 12z" fill="#5473CC" />
            <path d="M78.25 36.84C73.475 31.432 66.5 28 58.71 28c-14.39 0-26.06 11.64-26.06 26 0 14.355 11.67 26 26.058 26 7.79 0 14.766-3.432 19.543-8.843-4.04-4.58-6.51-10.57-6.51-17.157 0-6.588 2.47-12.58 6.516-17.16z" fill="#ED4A4A" />
            <path d="M78.25 36.84c-4.043 4.58-6.514 10.574-6.514 17.16s2.47 12.576 6.515 17.157c4.05-4.58 6.52-10.57 6.52-17.157 0-6.588-2.47-12.58-6.513-17.16z" fill="#EA564B" />
            <path d="M97.793 28c-7.79 0-14.766 3.432-19.542 8.84-1.123 1.28-2.11 2.678-2.98 4.16h5.96c.95 1.625 1.69 3.377 2.27 5.2H72.97c-.53 1.672-.912 3.403-1.092 5.2H84.59c.09.858.176 1.716.176 2.6 0 .88-.052 1.745-.138 2.6H71.87c.18 1.797.562 3.528 1.09 5.2h10.57c-.58 1.83-1.36 3.567-2.31 5.2h-5.953c.863 1.477 1.853 2.878 2.98 4.157C83.025 76.567 90 80 97.79 80c14.39 0 26.057-11.645 26.057-26 .003-14.36-11.665-26-26.054-26z" fill="#FFAF38" />
        </g>
    </svg>
);

export default withIconContainer(IconCardMastercard);
